import { Card as ChakraCard } from '@chakra-ui/react';

// Re-export the Chakra Card components with our custom recipe applied through the theme system
export const Card = ChakraCard;
